
import moment from 'moment';
import 'moment/locale/he';
import { MessageProps } from '../../../typings/messages';

export type TicksProps = {
    currentMessage: MessageProps,
    isMe: boolean;
    chatRecipientNickName: string;
}

const Ticks = ({ currentMessage, isMe, chatRecipientNickName }: TicksProps) => {
    const TIME_FORMAT = 'LT';
    const renderTime = () => {
        return moment(currentMessage.createdAt)
            .locale('he')
            .format(TIME_FORMAT)
    }

    return (

        <div className="talk_info">
            {isMe ? <span >אני,&nbsp;</span> : <span> {chatRecipientNickName},&nbsp;</span>}
            <div>{renderTime()}</div>
            {/* {currentMessage.received &&
                <div className="talk_ic read">
                    <img src="/images/ic_read.svg" loading="lazy" alt="" />
                </div>

            } */}
            {currentMessage.sent &&
                <div className="talk_ic noread">
                    <img src="/images/ic_noread.svg" loading="lazy" alt="" /></div>
            }
            {currentMessage.pending &&
                <div className="talk_ic clock">
                    <img src="/images/ic_clock.svg" loading="lazy" alt="" /></div>
            }

        </div>

    )

}

export default Ticks;